import { Button, Form } from 'antd';
import { FC } from 'react';
import Card, { CardButtonWrap } from 'components/Card';
import RadioSelect from 'modules/Transfer/components/RadioSelect';
import withTransferForm, { PageIdEnum, TransferFormProps } from '../../../withTransferForm';
import { PARTIAL_ACATS_BASE_PATH } from '../helper';
import { ChooseTransferTypePageFormutil } from '../type';

const selectOptions = [
    { label: __('TRANSFER:Full'), value: 'full' },
    { label: __('TRANSFER:Partial'), value: 'partial' }
];

const ChooseTransferType: FC<TransferFormProps<ChooseTransferTypePageFormutil>> = ({ $formutil, onSubmit }) => {
    const {
        $params: { transfer_type }
    } = $formutil;

    return (
        <Card form>
            <h3 className="transfer-title">{__('Transfer Details')}</h3>
            <Form
                noValidate
                layout="vertical"
                className="mt-4"
                onFinish={() => onSubmit(transfer_type === 'full' ? '../preview' : '../partial-details')}>
                <RadioSelect
                    name="transfer_type"
                    label={__('Transfer Type')}
                    options={selectOptions}
                    $defaultValue="full"
                />
                <CardButtonWrap className="mt-5">
                    <Button size="large" type="primary" htmlType="submit">
                        {__('Next')}
                    </Button>
                </CardButtonWrap>
            </Form>
        </Card>
    );
};

export default withTransferForm({
    step: 3,
    id: PageIdEnum.CHOOSE_TRANSFER_TYPE,
    basePath: PARTIAL_ACATS_BASE_PATH,
    ensure: [PageIdEnum.BROKER, PageIdEnum.CHECK]
})(ChooseTransferType);
